import { createAttractionTranslationsConfig } from '@/config/objects/attraction-translations';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Attraction translation form page for editing translations
 */
export function AttractionTranslationFormPage() {
  const { attractionId, translationId } = useParams<{ attractionId: string; translationId: string }>();
  const navigate = useNavigate();

  const translationsConfig = useMemo(
    () => (attractionId ? createAttractionTranslationsConfig(attractionId) : null),
    [attractionId],
  );

  if (!attractionId || !translationsConfig) {
    return (
      <PageContainer>
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Invalid URL</h2>
          <p className="text-muted-foreground">Attraction ID is required</p>
        </div>
      </PageContainer>
    );
  }

  const isEditMode = translationId && translationId !== 'new';
  const itemId = isEditMode ? translationId : undefined;

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Attractions', href: '/attractions' },
    { label: 'Attraction', href: `/attractions/${attractionId}` },
    { label: 'Translations', href: `/attractions/${attractionId}` },
    { label: 'Edit Translation', current: true },
  ];

  return (
    <PageContainer>
      <CrudFormView
        config={translationsConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={() => {
          // Navigate back to attraction detail page
          navigate(`/attractions/${attractionId}`);
        }}
      />
    </PageContainer>
  );
}
